import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home.vue')
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/company',
    name: 'company-page',
    component: () => import(/* webpackChunkName: "about" */ '../views/company.vue')
  },
  {
    path: '/mainIndustry',
    name: 'main-industry',
    component: () => import(/* webpackChunkName: "about" */ '../views/mainIndustry.vue')
  },
  {
    path: '/functions',
    name: 'function-s',
    component: () => import(/* webpackChunkName: "about" */ '../views/functions.vue')
  },
  {
    path: '/products',
    name: 'product-s',
    component: () => import(/* webpackChunkName: "about" */ '../views/products.vue')
  },
  {
    path: '/stockPoints',
    name: 'stock-points',
    component: () => import(/* webpackChunkName: "about" */ '../views/stockPoints.vue')
  },
  {
    path: '/contactUs',
    name: 'contact-us',
    component: () => import(/* webpackChunkName: "about" */ '../views/contactUs.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
